export default __webpack_public_path__ + "static/media/dungeon_brick_landing.77ad2408.png";